module.exports = __webpack_public_path__ + "img/VideoPromo-icon.6f5245cf.svg";